import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import { getFormData } from '../../common';

class UserLogin extends React.Component {
  onSubmit(evt) {
    evt.preventDefault();
    const url = evt.target.action;
    const formData = getFormData(evt.target);

    if (!formData.username || !formData.password) {
      window.Toast.danger("이메일과 비밀번호를 입력하세요.");
      return;
    }

    axios.post(url, formData).then((res) => {
      if (res.status === 401 || res.status === 404)
        window.Toast && window.Toast.danger("이메일 또는 비밀번호를 확인해주세요.");

      if (res.status === 200)
        window.location.href = "/everest-admin";
    });
  }

  onClickSignup(evt) {
    evt.preventDefault();
    window.location.href = "/everest-admin/signup";
  }

  onClickGoogle(evt) {
    evt.preventDefault();
    window.location.href = "/oauth2/everest/google/login";
  }

  onClickKakao(e) {
    e.preventDefault();
    window.location.href = "/oauth2/everest/kakao/login";
  }

  render() {
    const formStyle = { width: 250 };

    return (
      <div>

        <br />
        <form action={"/oauth2/everest/password/login"} onSubmit={this.onSubmit.bind(this)}>
          <div className={"form-group"}>
            <input style={formStyle} type={"text"} name={"username"} placeholder={"email"}></input>
          </div>
          <div className={"form-group"}>
            <input style={formStyle} type={"password"} name={"password"} placeholder={"password"}></input>
          </div>
          <div className={"form-group"}>
            <button style={formStyle} type={"submit"} className={"btn btn-primary"}>로그인</button>
          </div>
        </form>

        <hr />

        <div className={"form-group"}>
          <Link to={"/everest-admin/signup"}>
            <button style={formStyle} className={"btn btn-primary"}>회원가입 이동</button>
          </Link>
        </div>
        <div className={"form-group"}>
          <button style={formStyle} className={"btn btn-danger"} onClick={this.onClickGoogle.bind(this)}>구글로 시작하기</button>
        </div>
        <div className={"form-group"}>
          <button style={formStyle} className={"btn btn-warning"} onClick={this.onClickKakao.bind(this)}>카카오로 시작하기</button>
        </div>
      </div>
    );
  }
}

export { UserLogin };
